import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import trans from 'translate';
import ErrorListner from '../../Common/ErrorListner/ErrorListner';
import ShowAt from '../../Common/ShowAt/ShowAt';
import ProtectedContent from '../ProtectedContent/ProtectedContent';

const ProtectedRoute = ({ redirectionError, redirectTo, loading, ...rest }) => (
  <>
    <ProtectedContent {...rest}>
      {({ isAuthed }) => (
        <ShowAt at={!loading}>
          {isAuthed ? (
            <Route {...rest} />
          ) : (
            <>
              <ErrorListner errorMsg={trans(redirectionError)} {...rest} />
              <Redirect to={redirectTo} {...rest} />
            </>
          )}
        </ShowAt>
      )}
    </ProtectedContent>
  </>
);

export default ProtectedRoute;

ProtectedRoute.defaultProps = {
  redirectionError: '',
  loading: false,
  redirectTo: '/',
  loadingMsg: '',
  authDep: true,
};
ProtectedRoute.propTypes = {
  authDep: PropTypes.any,
  redirectionError: PropTypes.string,
  redirectTo: PropTypes.string,
  loadingMsg: PropTypes.string,
  loading: PropTypes.bool,
};
